<mat-form-field appearance="none"
                floatLabel="always"
                class="date-picker-container w-100">
  <mat-label class="medium color-navi" *ngIf="shouldShowLabel">
    <span>{{inputLabel}}</span>
    <span *ngIf="isRequired" class="color-error">*</span>:
  </mat-label>
  <input matInput [matDatepicker]="picker"
         placeholder="mm/dd/yyyy"
         autocomplete="off"
         [required]="useRequiredProperty ? isRequired : false"
         (focus)="focusInput()"
         (blur)="blurInput()"
         [min]="minDate"
         [max]="maxDate"
         class="date-picker-input w-100"
         [matDatepickerFilter]="filterDateFn"
         [attr.cdkFocusInitial]="hasFocusInitial"
         [attr.data-test-id]="testId ? testId + '_input' : null"
         [errorStateMatcher]="errorMatcher()"
         [formControl]="ctrl.control">
  <mat-datepicker-toggle matSuffix [for]="picker" [attr.data-test-id]="testId" #datePickerToggle>
    <span matDatepickerToggleIcon class="icon icon-calendar"></span>
  </mat-datepicker-toggle>

  <mat-datepicker #picker panelClass="date-picker-container"
                  [calendarHeaderComponent]="datePickerHeaderHeader"></mat-datepicker>

  <mat-hint *ngIf="inputHint && !isWarningVisible" class="d-flex no-wrap ai-start">
    <span class="icon icon-info icon-fs-md mr-q"></span>
    <span class="fs-sm">{{inputHint}}</span>
  </mat-hint>

  <mat-hint *ngIf="isWarningVisible" class="color-warning d-flex ai-start">
    <span class="icon icon-error icon-fs-md mr-q mt-e"></span>
    <span class="fs-sm">{{warningMessage}}</span>
  </mat-hint>
</mat-form-field>
